import { Modal } from "./Modal";

type Props<T> = {
  formData: T;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
};

export function UpdatesModal({
  formData,
  onChange,
  onClose,
  onSubmit,
  isSubmitting
}: Props<{ email: string }>) {
  return (
    <Modal title="Get Updates" onClose={onClose}>
      <p className="mb-4">
        Be the first to know when we launch. No noise, no spam, no 3rd parties,
        no ads — just MiValta.
      </p>
      <form className="flex flex-col gap-2" onSubmit={onSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={onChange}
          required
          className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
        />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
          >
            Cancel
          </button>          
          <button
            type="submit"
            disabled={isSubmitting}
            className={`px-4 py-2 text-sm bg-[#23c8a1] text-white rounded hover:brightness-110 transition ${
              isSubmitting ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
